// 2026 is the floor, so a visitor with a skewed clock cannot show an older year.
export const copyrightYear = () => Math.max(2026, new Date().getFullYear());
